import Config from "react-global-configuration"
import moment from "moment"
import { Version } from "../services"

const getClientVersion = async () => {
  const { clientBaseUri } = Config.get()

  try {
    const response = await fetch(`${clientBaseUri}/version.json?${moment().format("YYYYMMDDTHHmmss")}`)
    let newVersionAvailable = false
    if (response.ok) {
      const json = await response.json()
      newVersionAvailable = json.version !== Version
      if (newVersionAvailable) console.log("[APP]", `New version available ${json.version}`)
    }
    return newVersionAvailable
  } catch (e) {
    return false
  }
}

export { getClientVersion }
